import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { useAppSelector } from "../../../redux/hooks";
import { isTerminalStatus } from "../constants";

export function useUserUploads() {
  const userId = useAppSelector((state) => state.user.user_id);

  return useQuery({
    queryKey: [{ entity: "uploads", scope: "list", userId }],
    queryFn: async () =>
      await apiClient.listUploads({
        queries: {
          created_by: Number(userId),
          ordering: "-created_on",
          limit: 50,
        },
      }),
    select: (data) => data.results,
    enabled: !!userId,
    refetchOnMount: true,
    refetchInterval: (query) => {
      const hasActive = query.state.data?.results.some((u) => !isTerminalStatus(u.status));
      return hasActive ? 5000 : false;
    },
  });
}
